<!--
 * @Description: 运达新增界面
 * @Author: huzhibo
 * @Email: hzbfun@gmail.com
 * @Date: 2020/7/28 17:03
 -->
<template>
  <add-or-update pageType="add" />
</template>

<script>
// components
import addOrUpdate from "./components/addOrUpdate";

export default {
  name: "fenceAdd",
  components: { addOrUpdate }
};
</script>
